export default __webpack_public_path__ + "static/media/imgMiPadModal.729e3117.png";